import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export default function ScoreGauge({ score, size = 240 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);
  const r = size / 2 - 14;
  const c = 2 * Math.PI * r;

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, score, {
      duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, score]);

  return (
    <div ref={ref} data-testid="score-gauge" className="relative inline-block" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#27272a" strokeWidth="10" />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#ff5c1a" strokeWidth="10"
          strokeLinecap="butt" strokeDasharray={c}
          strokeDashoffset={c - (c * val) / 100}
          style={{ filter: "drop-shadow(0 0 12px rgba(204,255,0,0.45))" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-7xl leading-none">{val}</span>
        <span className="text-zinc-500 text-xs uppercase tracking-[0.25em] mt-1">/ 100</span>
      </div>
    </div>
  );
}
